import { Button } from '@mui/material'
import { FunctionComponent, PropsWithChildren, ReactNode } from 'react'
import cn from 'classnames'
import { MagicSpinner } from 'react-spinners-kit'
import Image from 'next/image'

interface Prop {
  onClick?: () => void
  loading?: boolean
  fullwidth?: boolean
  disabled?: boolean
  size?: 'sm' | 'lg'
  type?: 'contained' | 'soft' | 'outlined' | 'text'
  leadingIconImg?: string
  leadingIcon?: ReactNode
  trailingIconImg?: string
  trailingIcon?: ReactNode
  classNames?: string
}

const DarkButton: FunctionComponent<PropsWithChildren<Prop>> = (props) => {
  const style: ButtonStyle = getStyle(props.type ?? 'contained')
  return (
    <Button
      id='mobidarkbtn'
      type='submit'
      onClick={props.disabled === true ? () => { } : props.onClick}
      disabled={props.disabled}
      classes={{ disabled: style.disabled }}
      className={cn(props.fullwidth !== true ? 'w-fit px-4' : 'w-full', props.size === 'sm' ? 'h-10' : 'h-12', style.main, props.classNames)}
    >
      {
        props.loading === true
          ? <MagicSpinner size={30} color={style.loader} loading />
          : (
            <div className='flex flex-row items-center justify-between'>
              {props.leadingIcon === undefined && props.leadingIconImg !== undefined ? <Image draggable={false} width={30} height={30} alt='img' src={props.leadingIconImg ?? ''} className={props.size === 'sm' ? 'w-5 h-5' : 'w-[22px], h-[22px]'} /> : props.leadingIcon !== undefined && props.leadingIconImg === undefined ? props.leadingIcon : ''}
              {props.children !== undefined ? <p className='mx-2 text-sm font-semibold'>{props.children}</p> : null}
              {props.trailingIcon === undefined && props.trailingIconImg !== undefined ? <Image draggable={false} width={30} height={30} alt='img' src={props.trailingIconImg ?? ''} className={props.size === 'sm' ? 'w-5 h-5' : 'w-[22px], h-[22px]'} /> : props.trailingIcon !== undefined && props.trailingIconImg === undefined ? props.trailingIcon : ''}
            </div>
          )
      }

    </Button>
  )
}
interface ButtonStyle {
  disabled: string
  main: string
  loader: string
}
const getStyle = (type: string): ButtonStyle => {
  switch (type) {
    case 'soft':
      return { main: 'rounded-xl normal-case bg-surfaceMid hover:bg-[#EDEDED] active:bg-secondarySoftMain focus:bg-secondarySoftMain text-textHigh', disabled: 'opacity-20', loader: '#1F1F1F' }
    case 'outlined':
      return { main: 'rounded-xl normal-case border border-solid border-[#E5E5E5] bg-surfaceInverse hover:bg-[#EDEDED] active:bg-secondarySoftMain focus:bg-[#FDB5D6D6D6B5] hover:text-black text-textHigh', disabled: 'opacity-20', loader: '#B0B0B0' }
    case 'text':
      return { main: 'rounded-xl normal-case bg-transparent hover:bg-secondarySoftMain active:bg-secondarySoftMain focus:bg-secondarySoftMain text-textHigh', disabled: 'opacity-20', loader: '#B0B0B0' }
    default:
      return { main: 'rounded-xl normal-case bg-secondary hover:bg-[#1F1F1F] active:bg-[#1F1F1F] focus:bg-secondary text-textInverse', disabled: 'opacity-20', loader: '#B0B0B0' }
  }
}

export default DarkButton
